<template>
    <vue-scroll class="login-page align-vertical">
        <div class="form-wrapper align-vertical-middle">
            <div class="form-box card-base card-shadow--extraLarge">
                <img class="image-logo" :src="logo" alt="logo" />
                <form @submit.prevent="login" v-if="!success">
                    <float-label class="styled">
                        <input
                            type="email"
                            :class="form.state('email')"
                            placeholder="E-mail"
                            v-model="form.email"
                        />
                        <form-feedback :form="form" field="email" />
                    </float-label>
                    <float-label class="styled">
                        <input
                            type="password"
                            :class="form.state('password')"
                            placeholder="Password"
                            v-model="form.password"
                        />
                        <form-feedback :form="form" field="password" />
                    </float-label>
                    <float-label class="styled">
                        <input
                            type="password"
                            :class="form.state('email')"
                            placeholder="Confirm Password"
                            v-model="form.password_confirmation"
                        />
                        <form-feedback
                            :form="form"
                            field="password_confirmation"
                        />
                    </float-label>
                    <div class="flex text-center center pt-30 pb-10">
                        <el-button
                            :loading="form.busy"
                            plain
                            size="small"
                            @click.prevent="resetPassword"
                            class="login-btn tada animated"
                        >
                            Reset Password
                        </el-button>
                    </div>
                </form>
                <div class="text-center center pt-30 pb-10" v-if="success">
                    <el-alert
                        class="text-center"
                        title="Your password has been reset successfully."
                        type="success"
                        :closable="false"
                        center
                        show-icon
                    >
                    </el-alert>
                    <el-button
                        :loading="form.busy"
                        icon="mdi mdi-home"
                        plain
                        size="small"
                        @click.prevent="goHome()"
                        class="mt-20 login-btn tada animated"
                    >
                        Home
                    </el-button>
                </div>
            </div>
        </div>
    </vue-scroll>
</template>

<script>
import * as Getters from "../../../store/constants/getters";

export default {
    data() {
        return {
            form: new Form({
                email: null,
                password: null,
                password_confirmation: null,
                token: null,
            }),
            success: false,
        };
    },
    computed: {
        logo() {
            return this.$store.getters[Getters.GET_LOGO];
        },
    },
    mounted() {
        this.form.token = this.$route.params["token"];
    },
    methods: {
        resetPassword() {
            App.post("/password/reset", this.form).then(() => {
                this.success = true;
            });
        },
        goto(path) {
            this.$router.push(path);
        },
        goHome() {
            window.location = "/home";
        },
    },
};
</script>

<style lang="scss">
@import "../../../../assets/scss/variables";

.login-page {
    background: $corwin-green;
    margin-left: -30px;
    margin-right: -30px;

    .form-wrapper {
        width: 100%;
    }

    .form-box {
        width: 100%;
        max-width: 340px;
        padding: 30px;
        box-sizing: border-box;
        margin: 20px auto;

        a {
            font-size: 14px;
            color: $text-color-accent;
            text-decoration: none;
            font-weight: 500;
        }

        .image-logo {
            width: 80px;
            margin: 0 auto 30px;
            display: block;
        }

        .login-btn,
        .social-btn {
            width: 160px;

            &.google {
                margin-bottom: 10px;
                background-color: #d73d32;
                color: white;

                &:hover {
                    border-color: #d73d32;
                }
            }
            &.facebook {
                background-color: #3f5c9a;
                color: white;

                &:hover {
                    border-color: #3f5c9a;
                }
            }
        }

        .signin-box {
            font-size: 14px;
        }
    }
}

@media (max-width: 768px) {
    .layout-container .container .view.login-page {
        margin-left: -5px;
        margin-right: -5px;
        max-width: calc(100% + 10px);
    }
}
</style>
